export default __webpack_public_path__ + "static/media/whatsapp_logo.c9db48b0.svg";